import wx from 'weixin-js-sdk'
import { MessageBox } from 'mint-ui'
import { isEmpty } from '@yxcx/util'
import { toBindScoreTicket, toBindScoreTicketUnified, getOpRedirectUri, filterParams } from '@util/navigation'
import Account from '@lib/account'
import { app } from '@util/platform'
import { jump } from '@util/function'

export const forbidCookie = () => {
  if (!navigator.cookieEnabled) {
    MessageBox.alert('浏览器cookie被禁用，请先开启~')
    return true
  }
  return false
}

export const forbidLogin = (customerInfo) => {
  const { operatorStatus, name } = customerInfo
  if (operatorStatus !== 1) {
    MessageBox.alert(`企业${name}已被禁止登录，如有疑问，请联系公司相关人员 ~`)
    return true
  }
  return false
}

/**
 * 登录类型
 * 1、星享福、星享福企业版统一登录
 * 2、星享福、星享福企业版定制登录
 * 3、星享福微信绑定登录
 * 4、星享福微信统一登录
 */
export const LoginType = {
  OP_UNIFIED: 1,
  OP: 2,
  OP_WECHAT: 3,
  OP_UNIFY_WECHAT: 4,
}

/**
 * 获取登录类型
 *
 * @param {object} query vue route query
 * @returns LoginType
 */
export const getLoginType = (query) => {
  const { code } = query
  const { hasLoginToken } = useLoginToken(query)
  const { hasOpenId } = useOpenId(query)
  // 统一登录
  if (isEmpty(code)) {
    return hasOpenId ? LoginType.OP_UNIFY_WECHAT : LoginType.OP_UNIFIED
  }
  // 定制域名登录
  return hasLoginToken ? LoginType.OP_WECHAT : LoginType.OP
}

/**
 * 星享福、星享福企业版统一登录
 */
export const handleUnifiedOpLoginResult = (res, opts) => {
  const { isRegistered, loginToken } = res
  const { query, store } = opts

  // 未注册
  if (!isRegistered) {
    // 跳转公共绑卡页
    return toBindScoreTicketUnified({
      cb: query.redirectUri,
      loginToken,
      env: store.state.env,
      openId: query.openId,
    })
  }

  afterLoginSuccess(res, opts)
}

export const afterLoginSuccess = async (res, opts) => {
  const { isBindMultiCompany } = res
  const { router, query } = opts

  // 在多个企业的通讯录
  if (isBindMultiCompany) {
    return execBindMultiCompany(res, {
      router,
      query,
    })
  }

  // 登录成功，跳转...
  execLoginSuccess(res, opts)
}

/**
 * 星享福、星享福企业版定制登录
 */
export const handleOpLoginResult = (res, opts) => {
  const { isRegistered } = res
  const { query, customerInfo } = opts

  if (!isRegistered) {
    // 绑卡
    return toBindScoreTicket({
      mallCode: query.code,
      loginToken: res.loginToken,
      operatorId: customerInfo.operatorId,
      cb: query.redirectUri,
    })
  }

  // 登录成功，跳转...
  execLoginSuccess(res, opts)
}

// 绑定多个企业
export const execBindMultiCompany = (res, opts) => {
  const { router, query } = opts
  Account.setLoginSuccessData(res)
  router.replace({
    name: 'login_open_company',
    query: filterParams({ redirectUri: query.redirectUri }),
  })
}

/**
 * 登录成功
 *
 * @param {object} res
 * @param {object} opts
 */
export const execLoginSuccess = (res, opts) => {
  const { query } = opts

  if (app.isMiniProgram()) {
    return navigateBackMiniProgram(res)
  }

  Account.setLoginSuccessData(res)
  const jumpUrl = getOpRedirectUri({
    cb: query.redirectUri,
    mallCode: res.mallInfo.mallCode,
  })
  console.log('jumpUrl====', jumpUrl)
  jump({ url: jumpUrl, isReplace: false })
}

/**
 * 登录成功返回小程序
 *
 * @param {object} res 登录信息
 */
export const navigateBackMiniProgram = (res) => {
  const { userInfo, mallInfo, hireStatus } = res

  // 只有在职员工才能登录小程序，是否入职  1-在职 2-离职
  if (+hireStatus === 2) {
    return
  }

  const data = {
    ...userInfo,
    operatorId: mallInfo.operatorId,
    code: mallInfo.mallCode,
  }
  wx.miniProgram.postMessage({
    data,
  })
  wx.miniProgram.navigateBack()
}

export const useLoginToken = (query) => {
  const loginToken = query.loginToken
  return {
    loginToken,
    hasLoginToken: !!loginToken,
  }
}

export const useOpenId = (query) => {
  const openId = query.openId
  return {
    openId,
    hasOpenId: !!openId,
  }
}
